// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/open-app-store/open-app-store.component.scss
// module id = 422
// module chunks = 0